import styled from 'styled-components'

export const ModalWrap = styled.div`
  position: relative;

  .dc4-report-modal .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
    font-family: Roboto, sans-serif;
  }

  .dc4-report-modal .ant-modal-header {
    padding: 24px 24px 0;
    border-bottom: none;
    border-radius: 16px 16px 0 0;
  }

  .dc4-report-modal .ant-modal-title {
    color: #213f68;
    font-family: Roboto, sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
  }

  .dc4-report-modal .ant-modal-close {
    top: 20px;
    right: 16px;
  }

  .dc4-report-modal .ant-modal-close-x {
    width: 40px;
    height: 40px;
    line-height: 40px;
    color: #4c4c4c;
    font-size: 16px;
  }

  .dc4-report-modal .ant-modal-body {
    padding: 12px 24px 8px;
  }

  .dc4-report-modal .ant-modal-footer {
    padding: 16px 24px 24px;
    border-top: none;
  }

  .dc4-report-modal .ant-modal-footer .ant-btn {
    height: 40px;
    padding: 0 16px;
    border: none;
    border-radius: 8px;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 40px;
    box-shadow: none;
  }

  .dc4-report-modal .ant-modal-footer .ant-btn-default {
    color: #4c4c4c;
    background: #f0f0f0;
  }

  .dc4-report-modal .ant-modal-footer .ant-btn-default:hover,
  .dc4-report-modal .ant-modal-footer .ant-btn-default:focus {
    color: #4c4c4c;
    background: #e6e6e6;
  }

  .dc4-report-modal .ant-modal-footer .ant-btn-primary {
    color: #fff;
    background: #2684ff;
  }

  .dc4-report-modal .ant-modal-footer .ant-btn-primary:hover,
  .dc4-report-modal .ant-modal-footer .ant-btn-primary:focus {
    color: #fff;
    background: #1b73e8;
  }

  .dc4-report-modal .ant-modal-footer .ant-btn-primary[disabled],
  .dc4-report-modal .ant-modal-footer .ant-btn-primary[disabled]:hover {
    color: #fff;
    background: #2684ff;
    opacity: 0.48;
  }

  .dc4-report-modal .ant-calendar-picker {
    width: 100%;
  }

  .dc4-report-modal .ant-calendar-picker-input.ant-input {
    height: 40px;
    border-width: 2px;
    border-color: #d9d9d9;
    border-radius: 4px;
    color: #363636;
    font-family: Roboto, sans-serif;
    font-size: 14px;
  }

  .dc4-report-modal .ant-calendar-picker-input.ant-input::placeholder {
    color: #8c8c8c;
  }

  .dc4-report-modal .ant-calendar-picker-icon {
    color: #8c8c8c;
  }

  .ant-calendar-cell:has(.dc4-in-range) {
    background: #e6f4ff;
  }

  .ant-calendar-cell:has(.dc4-range-start):not(:has(.dc4-range-end)) {
    background: linear-gradient(90deg, transparent 50%, #e6f4ff 50%);
  }

  .ant-calendar-cell:has(.dc4-range-end):not(:has(.dc4-range-start)) {
    background: linear-gradient(90deg, #e6f4ff 50%, transparent 50%);
  }

  .ant-calendar-selected-day:has(.dc4-range-start),
  .ant-calendar-selected-day:has(.dc4-range-end),
  .ant-calendar-selected-day:has(.dc4-in-range) {
    background: transparent;
  }

  .ant-calendar-cell:has(.dc4-in-range) .ant-calendar-date {
    background: transparent;
    border-radius: 0;
  }

  .ant-calendar-date.dc4-range-start,
  .ant-calendar-date.dc4-range-end,
  .ant-calendar-selected-day .ant-calendar-date.dc4-range-start,
  .ant-calendar-selected-day .ant-calendar-date.dc4-range-end {
    background: #2684ff;
    color: #fff;
    border-radius: 50%;
  }

  .ant-calendar-cell:has(.dc4-in-range):hover {
    background: #bae0ff;
  }

  .ant-calendar-cell:has(.dc4-range-start):not(:has(.dc4-range-end)):hover {
    background: linear-gradient(90deg, transparent 50%, #bae0ff 50%);
  }

  .ant-calendar-cell:has(.dc4-range-end):not(:has(.dc4-range-start)):hover {
    background: linear-gradient(90deg, #bae0ff 50%, transparent 50%);
  }

  .ant-calendar-date.dc4-range-start:hover,
  .ant-calendar-date.dc4-range-end:hover {
    background: #1b73e8;
    color: #fff;
  }
`

export const Description = styled.p`
  margin: 0 0 16px;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

export const EmptyColumnsBanner = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 20px;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #f5f5f5;
  color: #363636;
`

export const BannerIcon = styled.span`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 14px;
  line-height: 24px;
  color: #4c4c4c;

  svg {
    width: 14px;
    height: 14px;
  }
`

export const BannerContent = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

export const BannerText = styled.p`
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

export const MoreDetailsButton = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: none;
  background: transparent;
  color: #2684ff;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: #1b73e8;
  }

  svg {
    width: 12px;
    height: 12px;
  }
`

export const PeriodSection = styled.div`
  margin-bottom: 16px;
`

export const PeriodTitle = styled.h3`
  margin: 0 0 12px;
  color: #213f68;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`

export const PeriodFields = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 0;
`

export const PeriodField = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const FieldLabel = styled.label`
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

export const MaxMonthsHint = styled.p`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0 0;
  color: #213f68;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
    color: #213f68;
  }
`

export const PreviewBanner = styled.div<{ $variant?: 'info' | 'warning' }>`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
  min-height: 40px;
  padding: 8px 12px;
  border: 1px solid
    ${({ $variant }) => ($variant === 'warning' ? '#ffe58f' : '#9ecffa')};
  border-radius: 8px;
  background: ${({ $variant }) =>
    $variant === 'warning' ? '#fffbe6' : '#e6f4ff'};
  color: ${({ $variant }) => ($variant === 'warning' ? '#363636' : '#213f68')};
`

export const PreviewBannerIcon = styled(BannerIcon)<{
  $variant?: 'info' | 'warning'
}>`
  color: ${({ $variant }) => ($variant === 'warning' ? '#faad14' : '#213f68')};
`

export const PreviewBannerText = styled.p<{ $variant?: 'info' | 'warning' }>`
  margin: 0;
  color: ${({ $variant }) => ($variant === 'warning' ? '#363636' : '#213f68')};
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  strong {
    font-weight: 700;
  }
`

export const EmptyColumnsList = styled.ul`
  margin: 0;
  padding-left: 20px;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`

export const EmptyColumnsIntro = styled.p`
  margin: 0 0 12px;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`
